import { Pipe, PipeTransform } from '@angular/core';

import { SubItem } from '../models/item-list-selection.model';

@Pipe({ name: 'visibleItems' })
export class VisibleItemsPipe implements PipeTransform {
  public transform(items: SubItem[]): SubItem[] {
    return items.filter((item) => !item.hide);
  }
}
